export default __webpack_public_path__ + "static/media/avatar_16.4275249b.png";